export default __webpack_public_path__ + "media/db50f40328e501e650e855d1538aa258a60f5cb4db31365c63ff3f335fdebbe8.svg";